import { deduplicateGovtOpportunityEntities } from './opportunityDeduplication';

export interface GovtOpportunityEntityLike {
  id: string;
  entity_type?: string;
  data?: Record<string, unknown>;
  created_at?: string;
  updated_at?: string;
}

export interface SemanticSearchReplacement<T extends GovtOpportunityEntityLike> {
  matchedIds: Set<string>;
  entities: T[];
  matchCount: number;
}

/** Whether a background semantic upgrade should run after keyword results render. */
export function shouldRunSemanticUpgrade(term: string): boolean {
  return term.trim().length > 0;
}

/**
 * Ignore stale semantic responses when the user has submitted a newer search.
 */
export function shouldApplySemanticResults(requestedTerm: string, activeTerm: string): boolean {
  return requestedTerm.trim() === activeTerm.trim() && activeTerm.trim().length > 0;
}

/**
 * Merge semantic matches with keyword results (union). Keyword hits are always kept.
 */
export function buildSemanticSearchReplacement<T extends GovtOpportunityEntityLike>(
  keywordEntities: T[],
  semanticEntities: T[]
): SemanticSearchReplacement<T> {
  const byId = new Map<string, T>();
  for (const entity of keywordEntities) {
    byId.set(String(entity.id), entity);
  }
  for (const entity of semanticEntities) {
    byId.set(String(entity.id), entity);
  }
  const entities = deduplicateGovtOpportunityEntities(Array.from(byId.values()));
  return {
    matchedIds: new Set(entities.map((o) => String(o.id))),
    entities,
    matchCount: entities.length,
  };
}
